import { COLORS } from "@styles";

export enum PaymentMethodAvatarStyle {
  DEFAULT = 'default',
  WARNING = 'warning',
}

export const styles = {
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  topSectionContainer: {
    display: 'flex',
    gap: '1rem',
    color: COLORS.NEUTRAL_LIGHT_3,
    width: '100%',
  },
  divider: {
    borderColor: COLORS.BORDER_DARK,
  },
  backButtonContainer: {
    display: 'flex',
    gap: '0.25rem',
    alignItems: 'center',
    padding: '0.5rem 1.5rem',
    cursor: 'pointer',
    borderRadius: '0.5rem',
    '&:hover': {
      backgroundColor: COLORS.NEUTRAL_DARK_2,
    },
  },
  organizationInfoSectionContainer: {
    display: 'flex',
    gap: '1rem',
    width: '65%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  organizationNameContainer: {
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
  },
  revenueSectionContainer: {
    display: 'flex',
    gap: '1rem',
    justifyContent: 'space-between',
    width: '100%',
  },
  revenueItemsContainer: {
    display: 'flex',
    gap: '3rem',
  },
  revenueItemContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  } as React.CSSProperties,
  revenueItemTitle: {
    fontSize: '0.75rem',
  },
  revenueItemValue: {
    fontSize: '1.5rem',
    fontWeight: 600,
  },
  monthlyRevenueItemValue: {
    fontSize: '1.25rem',
    fontWeight: 600,
  },
  billingDetailsContainer: {
    display: 'flex',
    gap: '1rem',
    color: COLORS.NEUTRAL_LIGHT_3,
    width: '100%',
    marginTop: '1rem',
    border: `1px dashed ${COLORS.BORDER_DARK}`,
    borderRadius: '1rem',
    padding: '1.5rem',
  },
  billingDivider: {
    borderStyle: 'dashed',
    borderColor: COLORS.BORDER_DARK,
  },
  billingContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.25rem',
    width: '50%',
    flex: '1',
  } as React.CSSProperties,
  billingContentHeaderWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  billingContentHeaderItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  } as React.CSSProperties,
  planDetailsWrapper: {
    display: 'flex',
    gap: '1rem',
    width: '50%',
    justifyContent: 'flex-end',
  } as React.CSSProperties,
  planDetailsItem: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'right',
  } as React.CSSProperties,
  trialItem: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'right',
    paddingRight: '1.5rem',
    borderRight: `1px solid ${COLORS.BORDER_DARK}`,
  } as React.CSSProperties,
  seatsUsageContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    marginTop: '1.5rem',
  } as React.CSSProperties,
  seatCostContainer: {
    display: 'flex',
    gap: '0.5rem',
    justifyContent: 'space-between',
    alignItems: 'center',
  } as React.CSSProperties,
  seatCostItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  } as React.CSSProperties,
  paymentMethodHeaderWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  } as React.CSSProperties,
  paymentMethodHeaderItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  } as React.CSSProperties,
  paymentMethodHeaderAction: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '0.5rem',
    borderRadius: '0.5rem',
    '&:hover': {
      backgroundColor: COLORS.NEUTRAL_DARK_2,
    },
  },
  creditCardContainer: {
    display: 'flex',
    gap: '0.5rem',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: '1.5rem',
  } as React.CSSProperties,
  creditCardItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    height: '100%',
  } as React.CSSProperties,
  creditCardIconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0.5625rem',
    borderRadius: '1.5rem',
  } as React.CSSProperties,
  creditCardIconColor: {
    [PaymentMethodAvatarStyle.DEFAULT]: {
      backgroundColor: COLORS.NEUTRAL_DARK_2,
      color: COLORS.NEUTRAL_LIGHT_0,
    },
    [PaymentMethodAvatarStyle.WARNING]: {
      backgroundColor: COLORS.WARNING_NEUTRAL,
      color: COLORS.NEUTRAL_DARK_2,
    },
  },
  creditCardHeader: {
    [PaymentMethodAvatarStyle.DEFAULT]: {
      color: COLORS.NEUTRAL_LIGHT_3,
    } as React.CSSProperties,
    [PaymentMethodAvatarStyle.WARNING]: {
      color: COLORS.WARNING_DARK,
      fontWeight: 600,
      fontSize: '0.625rem',
      lineHeight: '1rem',
      textTransform: 'uppercase',
    } as React.CSSProperties,
  },
  creditCardDescription: {
    [PaymentMethodAvatarStyle.DEFAULT]: {
      color: COLORS.NEUTRAL_LIGHT_3,
    } as React.CSSProperties,
    [PaymentMethodAvatarStyle.WARNING]: {
      color: COLORS.NEUTRAL_LIGHT_3,
      fontSize: '0.875rem',
      lineHeight: '1rem',
      fontWeight: 600,
    } as React.CSSProperties,
  },
  nextRenewalContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '0.75rem',
    marginTop: '0.25rem',
  } as React.CSSProperties,
  creditCardMenu: {
    '& .MuiPaper-root': {
      borderRadius: '0.5625rem',
      padding: '0.25rem 0.5rem',
      minWidth: '15rem',
    },
  }
}
